<template>
    <div class="container mt-5">
        <div v-if="loading" class="text-center">
            <div class="spinner-border" role="status"></div>
            <p>جاري تحميل السؤال...</p>
        </div>
        <div v-else-if="noMoreQuestions" class="text-center">
            <!-- عرض رسالة عند عدم وجود أسئلة -->
            <p class="alert alert-warning">لا توجد المزيد من الأسئلة</p>
        </div>
        <div v-else>
            <div class="card shadow-lg p-4 question-box">
                <!-- Timer Section -->
                <div class="btn-quiz-box mt-5 mb-5">
                    <span class="bi" :class="question.is_favorite ? 'bi-heart-fill text-danger' : 'bi-heart text-muted'"
                        style="cursor: pointer; font-size: 20px;margin: 5px;padding: 10px 18px;cursor: pointer;font-size: 20px;"
                        @click="toggleFavorite(question)">
                    </span>

                    <span class="dropdown">
                        <button class="btn btn-secondary btn-smdropdown-toggle" type="button" id="dropdownMenuButton1"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            خيارات <i class="fa fa-list"></i>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li>
                                <span class="dropdown-item" data-bs-toggle="modal"
                                    @click.prevent="addReport(this.qbankId, this.question.id)" style="cursor: pointer;"
                                    data-bs-target="#add-report-modal">
                                    <i class="bi bi-flag-fill me-2"></i> بلاغ
                                </span>
                            </li>
                            <li>
                                <span class="dropdown-item" data-bs-toggle="modal"
                                    @click.prevent="addNote(this.qbankId, this.question.id)" style="cursor: pointer;"
                                    data-bs-target="#add-note-modal">
                                    <i class="bi bi-journal-plus me-2"></i> أضف ملاحظة
                                </span>
                            </li>
                            <li>
                                <span class="dropdown-item" data-bs-toggle="modal"
                                    @click.prevent="showNotes(this.qbankId, this.question.id)" style="cursor: pointer;"
                                    data-bs-target="#show-note-modal">
                                    <i class="bi bi-journals me-2"></i> عرض الملاحظات
                                </span>
                            </li>
                            <li>
                                <span class="dropdown-item" data-bs-toggle="modal"
                                    @click.prevent="aiHelp(this.qbankId, this.question.id)" style="cursor: pointer;"
                                    data-bs-target="#help-modal">
                                    <i class="fa fa-question-circle" aria-hidden="true"></i>
                                    علمني كيف الحل
                                </span>
                            </li>
                        </ul>

                    </span>
                    <span class="btn btn-light" data-bs-toggle="modal"
                        @click.prevent="aiHelp(this.qbankId, this.question.id)"
                        style="    float: left;cursor: pointer;color: #07c232;margin-left: 11px;"
                        data-bs-target="#help-modal">
                        <i class="fa fa-question-circle" style="color: #07c232;" aria-hidden="true"></i>
                        علمني كيف الحل
                    </span>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <span class="dropdown">
                        <button style="color: #03c100; font-weight: 700;"
                            class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton1"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            سؤال رقم {{ questionNo }} من {{ lastQuestion }}
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <!-- حلقة للتنقل بين الأسئلة من 1 إلى آخر سؤال -->
                            <li v-for="i in Array.from({ length: lastQuestion }, (_, index) => index + 1)" :key="i">
                                <span class="dropdown-item" :class="{ 'text-success': i === questionNo }"
                                    @click="goToQuestion(i)" style="cursor: pointer;">

                                    <!-- عرض العلامة إذا كانت ليست من قائمة الأسئلة غير المجابة -->
                                    <span v-if="!unanswered_questions.includes(i)"
                                        class="badge me-2 answered-circle"></span>

                                    سؤال رقم {{ i }} من {{ lastQuestion }}
                                </span>
                            </li>
                        </ul>
                    </span>


                    <div>
                        <span class="timer-text m-2">{{ formattedTime }}</span>
                        <button class="btn btn-sm btn-dark ml-2" @click="toggleTimer">
                            <i :class="timerRunning ? 'fas fa-pause' : 'fas fa-play'"></i>
                            {{ timerRunning ? 'إيقاف' : 'إستئناف ' }}
                        </button>
                    </div>
                </div>

                <!-- Question Content -->
                <h5 class="content-math card-title mb-4" :dir="getDirection(question?.content)"
                    v-html="cleanedContent(question.content)"></h5>
                <div v-if="question.file" style="text-align: center;">
                    <template v-if="isImage(question.file)">
                        <a :href="question.file" target="_blank">
                            <img style="max-height: 410px;" :src="question.file" alt="Question Image"
                                class="img-fluid mb-3" />
                        </a>
                    </template>
                    <template v-else>
                        <a :href="question.file" target="_blank" class="btn btn-link">📁 View File</a>
                    </template>
                </div>

                <div :dir="getDirection(question?.content)">
                    <!-- Render question based on type -->

                    <!-- Text Question -->
                    <div v-if="question.type === 3" class="text-question">
                        <textarea v-model="userAnswer" class="form-control mb-3"
                            :readonly="question.is_answered && !isEditing" style="min-height: 150px;" rows="9"
                            placeholder="اكتب إجابتك هنا...">{{ question.user_answer }}</textarea>

                        <div v-if="question.is_answered && !isEditing" class="mt-2">
                            <p><strong>إجابتك:</strong> {{ question.user_answer }}</p>
                            <button @click="editAnswer" class="btn btn-secondary btn-sm">تعديل الإجابة</button>
                        </div>

                    </div>

                    <!-- Multiple Choice Question -->
                    <div v-else-if="question.type === 1" class="multi-choose">
                        <div v-for="choice in question.choices" :key="choice.id"
                            class="form-check mb-3 d-flex align-items-center">
                            <label class="form-check-label flex-grow-1">
                                <input type="radio" :id="`choice-${choice.id}`" :value="choice.id" v-model="userAnswer"
                                    class="form-check-input me-2" :disabled="question.is_answered && !isEditing" />


                                <span class="content-math" v-html="cleanedContent(choice.content)"></span>
                            </label>

                            <b v-if="choice.id == question.user_answer" class="text-info">
                                إجابتك
                            </b>
                        </div>

                        <div v-if="question.is_answered && !isEditing">
                            <button @click="editAnswer" class="btn btn-secondary btn-sm">تعديل الإجابة</button>
                        </div>

                    </div>

                    <!-- True/False Question -->
                    <div v-else-if="question.type === 2" class="true-false-question" style="margin: 0 auto;width:200px">
                        <div v-for="choice in question.choices" :key="choice.id"
                            style="border: 1px solid #ddd;border-radius: 10px;padding: 10px;"
                            class="form-check mb-3 d-flex align-items-center">
                            <label class="form-check-label flex-grow-1">
                                <input type="radio" :id="`choice-${choice.id}`" :value="choice.id" v-model="userAnswer"
                                    class="form-check-input me-2" :disabled="question.is_answered && !isEditing" />


                                {{ choice.content }}
                            </label>

                            <b v-if="choice.id == question.user_answer" class="text-info">
                                إجابتك
                            </b>
                        </div>

                        <div v-if="question.is_answered && !isEditing">
                            <button @click="editAnswer" class="btn btn-secondary btn-sm">تعديل الإجابة</button>
                        </div>

                    </div>

                    <!-- Matching Question -->
                    <div v-else-if="question.type === 4">
                        <div class="row">
                            <div class="col-md-12">
                                <div v-if="question.is_correct == 1" class="alert alert-success text-center">
                                    <b>✔ إجابتك صحيحة</b>
                                </div>
                                <div v-else-if="question.is_correct == 0" class="m-1 alert alert-danger text-center">
                                    <b> ✘ إجابتك: غير صحيحة </b>
                                </div>
                            </div>
                            <div class="col-md-6">
                            </div>
                            <div class="col-md-6">
                                <h4 v-if="question.is_answered" class=" text-primary">إجابتك</h4>
                            </div>
                            <div class="col-md-6">
                                <h5 class="">العناصر على اليمين</h5>
                                <ul class="list-group">
                                    <li v-for="item in question.matching_options.right" :key="item.id"
                                        class="list-group-item">
                                        <span class="content-math" v-html="cleanedContent(item.content)"></span>

                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-6">
                                <div v-if="question.is_answered && isEditing">

                                    <h5>العناصر على اليسار (قابلة للتعديل)</h5>
                                    <ul class="list-group" ref="sortableLeft">
                                        <li v-for="item in question.matching_options.left" :key="item.id"
                                            class="list-group-item">
                                            <span class="content-math" v-html="cleanedContent(item.content)"></span>

                                        </li>
                                    </ul>

                                </div>
                                <div v-else>

                                    <h5>العناصر على اليسار</h5>
                                    <ul class="list-group" ref="sortableLeft">
                                        <li v-for="item in question.matching_options.left" :key="item.id"
                                            class="list-group-item">
                                            <span class="content-math" v-html="cleanedContent(item.content)"></span>

                                        </li>
                                    </ul>
                                    <button v-if="question.is_answered" @click="editAnswer"
                                        class="btn btn-secondary btn-sm mt-2">تعديل
                                        الإجابة</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h6 style="text-align: center; font-weight: 600; font-size: 12px;">
                        نسبة الإجابة الصحيحة بين جميع الطلاب
                        <span :class="question.correct_answers_percentage < 50 ? 'text-danger' : 'text-success'"
                            style="font-weight: 700;">
                            {{ question.correct_answers_percentage }} %
                        </span>
                    </h6>


                    <div v-if="question.is_answered && question.explanation">
                        <h6 class="mt-3">(Explanation) التوضيح :</h6>
                        <pre class="content-math" v-html="cleanedContent(question.explanation)"
                            style="font-family: 'SF Arabic' !important;"></pre>
                    </div>

                    <!-- عرض صورة التفسير أو رابط إذا كان موجود في explanation_file -->
                    <div v-if="question.is_answered && question.explanation_file">
                        <template v-if="isImage(question.explanation_file)">
                            <img :src="question.explanation_file" alt="Explanation Image" class="img-fluid mt-2" />
                        </template>
                        <template v-else>
                            <a :href="question.explanation_file" target="_blank" class="btn btn-link">📁 View
                                Explanation File</a>
                        </template>
                    </div>
                </div>
                <!-- Navigation Buttons -->
                <div class="d-flex justify-content-between mt-4">
                    <button class="btn btn-secondary" @click="previousQuestion">
                        <i class="fas fa-arrow-right"></i> السابق
                    </button>
                    <button class="btn btn-secondary float-left" @click="skipQuestion">
                        تخطي >>
                    </button>
                    <button class="btn btn-success float-left" style="background-color: #03c100" @click="nextQuestion">
                        التالي <i class="fas fa-arrow-left"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <AddReport />
    <AddNote />
    <HelpAi ref="aiRef" />

    <Notes ref="notesRef" />
</template>

<script>
import { apiUrl } from "@/utils/api";
import Sortable from "sortablejs";
import Swal from "sweetalert2";
import AddReport from "../AddReport.vue";
import AddNote from "../AddNote.vue";
import Notes from "../Notes.vue";
import HelpAi from "../HelpAi.vue";

import {
    favoriteQuestion,
} from "@/utils/questionService";

export default {
    components: {
        AddReport,
        AddNote,
        Notes,
        HelpAi
    },
    data() {
        return {
            token: localStorage.getItem("access_token"),
            qbankId: this.$route.query.qref,
            lastQuestion: this.$route.query.total,
            quizMode: this.$route.query.mode,
            questionNo: Number(this.$route.query.num) || 1,
            question: null,
            userAnswer: null,
            unanswered_questions: [],
            loading: true,
            timer: 0,
            timerInterval: null,
            timerRunning: true,
            noMoreQuestions: false, // متغير جديد

        };
    },
    computed: {
        formattedTime() {
            const minutes = String(Math.floor(this.timer / 60)).padStart(2, "0");
            const seconds = String(this.timer % 60).padStart(2, "0");
            return `${minutes}:${seconds}`;
        },
    },
    methods: {
        cleanedContent(rawResponse) {

            return rawResponse.replace(/\\\\/g, "\\");

        },
        renderMath() {
            if (window.MathJax && window.MathJax.typesetPromise) {
                this.$nextTick(() => {
                    const elems = document.querySelectorAll('.content-math');

                    elems.forEach(el => {
                        if (el.textContent.includes('📐')) {
                            // نحذف الرمز 📐 من المحتوى
                            el.innerHTML = el.innerHTML.replace('📐', '');

                            // ثم نمرر العنصر إلى MathJax
                            MathJax.typesetPromise([el]);
                        }
                    });
                });
            }
        },
        editAnswer() {
            if (this.question.type == 4) {
                setTimeout(() => {
                    this.initSortable();
                }, 1000);
            }
            this.isEditing = true;
        },
        saveAnswer() {
            this.question.user_answer = this.userAnswer;
            this.isEditing = false;
            // يمكنك هنا إضافة كود لإرسال التحديث إلى الخادم
        },
        async skipQuestion() {
            if (this.questionNo == this.lastQuestion) {
                this.nextQuestion();
                return;
            }
            // إعادة تعيين الحالة، والانتقال للسؤال التالي
            this.questionNo += 1;
            this.updateUrl();
            this.fetchQuestion();
            this.destroySortable();
        },
        async addNote(qbankNoteId, questionNoteId) {
            document.getElementById("qbankNoteId").value = qbankNoteId;
            document.getElementById("questionNoteId").value = questionNoteId;
        },
        async aiHelp(qbankHelpId, questionHelpId) {
            document.getElementById("questionHelpId").value = questionHelpId;
            this.$refs.aiRef.startExplanation()

        },
        isImage(file) {
            return /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i.test(file);
        },
        getDirection(text) {
            if (!text) return 'ltr';
            // إزالة الرموز والعلامات
            const cleanText = text.replace(/[:;.,/\()؟?!@#$%^&*[\]{}<>|_+=~`]/g, '');
            // التحقق من وجود أحرف عربية أو عبرية أو فارسية
            const rtlRegex = /[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/;
            return rtlRegex.test(cleanText) ? 'rtl' : 'ltr';
        },
        async addReport(qbankReportId, questionReportId) {
            document.getElementById("qbankReportId").value = qbankReportId;
            document.getElementById("questionReportId").value = questionReportId;

        },
        async showNotes(qbankNoteId, questionNoteId) {
            document.getElementById("qbankNoteId").value = qbankNoteId;
            document.getElementById("questionNoteId").value = questionNoteId;
            this.$refs.notesRef.showNotes()
        },
        async toggleFavorite(question) {
            try {
                favoriteQuestion(question.id);
                // عكس الحالة في الواجهة مباشرة
                question.is_favorite = !question.is_favorite;

                alertify.success(
                    question.is_favorite ? "تمت الإضافة إلى المفضلة" : "تمت الإزالة من المفضلة"
                );
            } catch (err) {
                console.error(err);
                alertify.error("حدث خطأ، حاول لاحقًا");
            }
        },
        favoriteQuestion,
        async fetchQuestion() {
            this.loading = true;
            this.noMoreQuestions = false; // إعادة تعيين الحالة عند كل طلب
            try {
                const response = await fetch(
                    `${apiUrl}/qbanks/${this.qbankId}/questions?number=${this.questionNo}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    if (!data.question) {
                        throw new Error("No more questions");
                    }
                    this.unanswered_questions = data.unanswered_questions;
                    this.question = data.question;
                    this.userAnswer = null;
                    if (this.question.is_answered) {
                        this.userAnswer = this.question.user_answer;
                    }

                    // Initialize SortableJS for matching questions
                    if (this.question.type === 4 && this.question.matching_options?.right) {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.initSortable();
                            }, 2000);
                        });
                    }
                } else if (response.status === 404) {
                    this.noMoreQuestions = true; // تعيين الحالة عند عدم وجود أسئلة
                } else {
                    console.error("فشل جلب الأسئلة");
                }
            } catch (error) {
                console.error("خطأ في جلب الأسئلة:", error);
                this.noMoreQuestions = true; // عرض رسالة عند أي خطأ
            } finally {
                this.loading = false;
            }
        },
        async nextQuestion() {
            this.isEditing = false;
            if (this.questionNo == this.lastQuestion) {
                const unansweredList = this.unanswered_questions;
                let unansweredMessage = "";

                if (unansweredList.length > 0 && this.userAnswer == null) {
                    if (unansweredList.length > 10) {
                        unansweredMessage = `لديك أكثر من 10 أسئلة غير مجابة`;
                    } else {
                        unansweredMessage = ` لم تجب على هذه الأسئلة بعد    : ${unansweredList.join(", ")}`;
                    }
                } else if (unansweredList.length > 0 && this.userAnswer != null) {
                    // الرقم الذي تريد حذفه
                    const numberToRemove = this.questionNo;

                    // إزالة الرقم من القائمة
                    const filteredList = unansweredList.filter(num => num !== numberToRemove);

                    if (filteredList.length > 10) {
                        unansweredMessage = `لديك أكثر من 10 أسئلة غير مجابة`;
                    }
                    if (filteredList.length > 0) {
                        unansweredMessage = `لم تجب على هذه الأسئلة بعد: ${filteredList.join(", ")}`;
                    } else {
                        unansweredMessage = "";

                    }
                } else {
                    unansweredMessage = "";
                }

                // رسالة التنبيه
                const confirmed = await Swal.fire({
                    title: "تأكيد إنهاء الاختبار",
                    html: `<p>هل أنت متأكد أنك تريد إنهاء الاختبار؟</p>
               <p style="color: #db1e1e;">${unansweredMessage}</p>`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "نعم، أكمل الاختبار",
                    cancelButtonText: "إلغاء",
                });

                if (confirmed.isConfirmed) {
                    // إرسال الإجابة النهائية
                    await this.submitAnswer();
                    // إتمام الاختبار
                    await this.completeQuiz();
                }
            }
            else {
                if (!this.question.is_answered) {

                    // إرسال الإجابة
                    await this.submitAnswer();
                    // التقدم للسؤال التالي
                    this.questionNo += 1;
                    this.updateUrl();
                    this.fetchQuestion();
                    this.destroySortable();

                }
                else {
                    await this.submitAnswer();
                    // التقدم للسؤال التالي
                    this.questionNo += 1;
                    this.updateUrl();
                    this.fetchQuestion();
                    this.destroySortable();
                }

            }
        },
        goToQuestion(questionNum) {
            this.questionNo = questionNum;
            // تحديث الـ URL بناءً على السؤال المختار
            this.$router.push({ query: { ...this.$route.query, num: this.questionNo } });
            this.fetchQuestion();
        },
        async completeQuiz() {
            try {
                const response = await fetch(
                    `${apiUrl}/qbanks/${this.qbankId}/complete`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                        },
                    }
                );
                if (response.ok) {
                    Swal.fire("تم بنجاح", "تم إنهاء الاختبار.", "success");
                    window.location.href = "qbank-summary?qbank=" + this.qbankId;
                } else {
                    Swal.fire("خطأ", "حدث خطأ أثناء إنهاء الاختبار.", "error");
                    window.location.href = "qbank-summary?qbank=" + this.qbankId;

                }
            } catch (error) {
                Swal.fire("خطأ", "تعذر الاتصال بالخادم.", "error");
            }
        },
        previousQuestion() {
            if (this.questionNo > 1) {
                this.questionNo -= 1;
                this.updateUrl();
                this.fetchQuestion();
                this.destroySortable();
            }
        },
        toggleTimer() {
            this.timerRunning = !this.timerRunning;

            // تشغيل أو إيقاف التايمر بناءً على الحالة
            if (this.timerRunning) {
                this.startTimer();
            } else {
                clearInterval(this.timerInterval);
            }

            // تحديد الرابط المناسب بناءً على حالة التايمر
            const endpoint = this.timerRunning
                ? `${apiUrl}/qbanks/${this.qbankId}/resume`
                : `${apiUrl}/qbanks/${this.qbankId}/pause`;

            // تنفيذ طلب الـ API
            fetch(endpoint, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${this.token}`,
                    "Content-Type": "application/json",
                },
            })
                .then(response => response.json())
                .then(data => {
                    console.log("Response:", data);

                    // إشعار بسيط باستخدام alert
                })
                .catch(error => {

                });
        },
        startTimer() {
            this.timerInterval = setInterval(() => {
                this.timer++;
            }, 1000);
        },

        updateUrl() {
            this.$router.push({ query: { ...this.$route.query, num: this.questionNo } });
        },
        async submitAnswer() {
            try {
                const formData = new FormData();

                // إعداد البيانات بناءً على نوع السؤال
                if (this.question.type === 3) {
                    // سؤال نصي
                    formData.append("answer", this.userAnswer);
                } else if (this.question.type === 1 || this.question.type === 2) {
                    // اختيار من متعدد أو صح/خطأ
                    formData.append("answer", this.userAnswer);
                } else if (this.question.type === 4) {
                    // مطابقة
                    this.question.matching_options.right.forEach((item, index) => {
                        formData.append(`answer[${index}][left_option_id]`, this.question.matching_options.left[index].id);
                        formData.append(`answer[${index}][right_option_id]`, item.id);
                    });
                }

                // إرسال الطلب إلى الخادم
                const response = await fetch(
                    `${apiUrl}/qbanks/${this.qbankId}/questions/${this.question.id}`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${this.token}`, // لا يتم تضمين Content-Type مع FormData
                        },
                        body: formData,
                    }
                );

                if (!response.ok) {
                    /*Swal.fire({
                        icon: "error",
                        title: "خطأ",
                        text: "حدث خطأ أثناء إرسال الإجابة. حاول مرة أخرى.",
                    });*/
                    return;
                }

                /*Swal.fire({
                    icon: "success",
                    title: "تم الإرسال",
                    text: "تم إرسال الإجابة بنجاح!",
                });*/
            } catch (error) {
                /*Swal.fire({
                    icon: "error",
                    title: "خطأ",
                    text: "حدث خطأ أثناء إرسال الإجابة. حاول مرة أخرى.",
                });*/
                console.error("حدث خطأ أثناء إرسال الإجابة:", error);
            }
        },

        initSortable() {
            const sortableLeft = this.$refs.sortableLeft;
            if (!sortableLeft) return;

            Sortable.create(sortableLeft, {
                group: "matching",
                animation: 150,
                onEnd: (evt) => {
                    const newOrder = Array.from(sortableLeft.children).map((child) => {
                        return this.question.matching_options.left.find(
                            (item) => item.content === child.innerText.trim()
                        );
                    });

                    this.question.matching_options.left = newOrder;
                },
            });
        },
        destroySortable() {
            const sortableLeft = this.$refs.sortableLeft;
            if (sortableLeft && sortableLeft._sortable) {
                sortableLeft._sortable.destroy();
            }
        },
    },
    updated() {
        this.renderMath();

    },
    mounted() {
        this.fetchQuestion();
        this.startTimer();
        this.renderMath();

    },
    beforeDestroy() {
        clearInterval(this.timerInterval);
    },
};
</script>

<style scoped>
.card {
    border-radius: 10px;
    border: 1px solid #07b12c;
}

.timer-text {
    font-size: 1.2rem;
    color: #ff5722;
    font-weight: bold;
}

textarea {
    resize: none;
}

.list-group-item {
    cursor: move;
}

.btn-outline-primary {
    font-size: 1.2rem;
    padding: 10px 20px;
    transition: all 0.3s ease;
    background-color: #9e9e9e1c;
}

.btn-outline-primary:hover,
.btn-outline-primary.active {
    background-color: #07b12c;
    color: #fff;
    border-color: #07b12c;
}

.answered-circle {
    padding: 4px;
    width: 5px !important;
    height: 4px;
    display: inline-block;
    /* border-radius: 72%; */
    background-color: #1a82e9
        /* اللون الأزرق الداكن */
}

.content-math {
    display: inline;
    /* تأكد أنه ما ينزل سطر */
    margin: 0;
    padding: 0;
    line-height: 1.4;
}
</style>